import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Ferie } from '../model/ferie';

@Injectable({
    providedIn: 'root'
  })
  export class FerieService{

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllFeries() 
    {
      return this._restClientService.load<Ferie[]>('ferie/get');
    }
      
    getFerieById(ferieId)
    {
      return this._restClientService.load<Ferie>('ferie/get/'+ferieId);
    }

    add(ferie) {
      return  this._restClientService.save<Ferie>('ferie/add', ferie);
    }
  
    update(ferie) {
      return  this._restClientService.put<Ferie>(`ferie/update`, ferie);
    }
    
    delete(id) 
    {
        return this._restClientService.delete<any>('ferie/delete/'+id);
    }
  

  

}